export const returnTopValue = (layoutValue: any) => {
  return layoutValue?.top - 85
}
export const returnLeftValue = (layoutValue: any) => {
  return layoutValue?.left
}

export const returnTopValueCalendar = (windowHeight: number, layoutValue: any) => {
  // const position = windowHeight - layoutValue?.top - layoutValue?.x + layoutValue?.height + 20
  console.log('windowHeight', windowHeight)
  const position = layoutValue?.x - 70
  return position
}
